import { Box } from '@mui/material';
import { CountryItem } from 'src/components/country-bar/types';
import { EXPLORE_COLORS } from './constants';
import { countryCoveragePct } from './countryLabel';

/**
 * Libellé d'un onglet de la CountryBar (Explore + Funnel).
 * - Option agrégée ("__all__") => "All" (pas de drapeau ni de couverture).
 * - Pays => code en majuscules + couverture % si dispo.
 * - `isSelected` (défaut true) : onglet actif = code sombre (valueDark) + % atténué
 *   (labelMuted) ; onglet inactif = tout grisé (#919EAB) comme sur le Funnel.
 */
export function CountryTabLabel({
  country,
  isSelected = true,
}: {
  country: CountryItem;
  isSelected?: boolean;
}) {
  const codeColor = isSelected ? EXPLORE_COLORS.valueDark : EXPLORE_COLORS.textDisabled;

  if (country.country_code === '__all__') {
    return (
      <Box component="span" sx={{ color: codeColor }}>
        All
      </Box>
    );
  }

  const pct = countryCoveragePct(country);
  const pctColor = isSelected ? EXPLORE_COLORS.labelMuted : EXPLORE_COLORS.textDisabled;
  return (
    <Box component="span">
      <Box component="span" sx={{ color: codeColor }}>
        {(country.country_code ?? '').toUpperCase()}
      </Box>
      {pct != null && (
        <Box component="span" sx={{ color: pctColor }}>
          {` (${pct}%)`}
        </Box>
      )}
    </Box>
  );
}
